import React, {ReactNode} from 'react'
import {StyledDiv} from '../../../../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {Box} from '@mui/material'
import {
    ApplyTitleForLandscape,
    HeaderAreaBox,
    HeaderAreaForLandscape,
    PageDivForLandscape
} from './NatAdminApplicatioPrintCommonStyle'
import {getPrintDate} from '../../helper/NatApplicationHelper'
import {convertToRoomNumberForResident} from '../../../../../common/util/Natutil'
import {NatEncloseInParenthesis} from './NatEncloseInParenthesis'

interface Props {
    condominiumName: string
    ridgeName: string
    roomNumber: string
    phoneNumber: string
    constructionStartDate: string
    constructionEndDate: string
}

export const NatVehicleForConstructionDocument: React.FC<Props> = props => {
    const {
        condominiumName,
        ridgeName,
        roomNumber,
        phoneNumber,
        constructionStartDate,
        constructionEndDate,
    } = props


    const applicantRoom = `${ridgeName} ${convertToRoomNumberForResident(roomNumber)}`

    return (<>
        <PageDivForLandscape>
            <HeaderAreaForLandscape>
                <HeaderAreaBox>
                    <Box m={'auto'}><ApplyTitleForLandscape>工事用車両</ApplyTitleForLandscape></Box>
                </HeaderAreaBox>
            </HeaderAreaForLandscape>
            <Box ml={'5mm'} mt={'5mm'} whiteSpace={'pre-wrap'}>
                　この車両は、専有部分の改修工事のために、管理組合の許可を受けて駐車しています。
                ご用の際は、下記住戸までご連絡ください。
            </Box>
            <Box margin={'8mm 0 0 10mm'} display={'flex'} flexDirection={'column'} width={'220mm'}>
                <Box>
                    <Box ml={'8mm'} mb={'5mm'}>
                        {renderApplicationDetail('マンション名', condominiumName)}
                        {renderApplicationDetail('住戸番号', applicantRoom)}
                        {renderApplicationDetail('電話番号', phoneNumber)}
                        <PrintApplicationDetailContainer>
                            <Box whiteSpace={'pre-wrap'}>工事日程</Box>
                        </PrintApplicationDetailContainer>
                        {renderApplicationDetail(<Indent>開始日</Indent>, renderConstructionDate(constructionStartDate))}
                        {renderApplicationDetail(<Indent>終了日</Indent>, renderConstructionDate(constructionEndDate))}
                        <Box mt={'5mm'}>
                            {renderApplicationDetail('作業時間', renderWorkingTime())}
                        </Box>
                    </Box>
                </Box>
            </Box>
        </PageDivForLandscape>
    </>)

    NatVehicleForConstructionDocument.displayName = 'NatVehicleForConstructionDocument'
}

const renderApplicationDetail = (title: string | ReactNode, value: string | ReactNode) => {
    return (
        <PrintApplicationDetailContainer>
            <Box whiteSpace={'pre-wrap'}>{title}</Box>
            <NatEncloseInParenthesis item={value} pageOrientation={'landscape'}/>
        </PrintApplicationDetailContainer>
    )
}

const renderConstructionDate = (date: string) => {
    const value = getPrintDate(date)

    return (
        <>
            <Box component={'span'} padding={'0 3mm 0 1mm'}>{value.year}</Box>年
            <Box component={'span'} padding={'0 4mm 0 4mm'}>{value.month}</Box>月
            <Box component={'span'} padding={'0 4mm 0 4mm'}>{value.day}</Box>日
        </>
    )
}

const renderWorkingTime = () => {
    return (
        <>
            <Box component={'span'} padding={'0 3mm 0 21mm'}/>時
            <Box component={'span'} padding={'0 4mm 0 20mm'}/>分
            <Box component={'span'} padding={'0 2mm 0 4mm'}/>～
            <Box component={'span'} padding={'0 6mm 0 20mm'}/>時
            <Box component={'span'} padding={'0 4mm 0 20mm'}/>分
        </>
    )
}

const PrintApplicationDetailContainer: StyledDiv = styled.div`
  display: flex;
  width: 100%;
`

const Indent: StyledDiv = styled.div`
  display: inline-block;
  text-indent: 1em;
  margin: 0;
`